// import babelpolyfill from 'babel-polyfill'
// import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import "babel-polyfill";
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
//import './assets/theme/theme-green/index.css'
// import VueRouter from 'vue-router'
import VueQuillEditor from 'vue-quill-editor'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(VueQuillEditor)
import store from './vuex/store'
import Vuex from 'vuex'
import Cookie from 'vue-cookie'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import router from './router'
// import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import filter from './util/filter.js'
import {
    forEachRoute
} from './common/js/util.js'

Vue.use(ElementUI)
// Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Cookie)
//NProgress.configure({ showSpinner: false }); 

// const router = new VueRouter({
//     routes
// })
import author from './api/api'
Vue.prototype.$author = author
Vue.prototype.$filter = filter
Vue.prototype.Imgurl = "http://moban.weiyingjia.org/h5/cloudimages/images/"
Vue.prototype.xiaojing = "http://117.78.34.224:82/#/" //测试
// Vue.prototype.$guanwang = "http://www.jvtdtest.top/" //测试
Vue.prototype.$guanwang = "https://www.jvtd.cn/" //正式

// Vue.prototype.$companyApproveUrl = "https://oaservice.jvtd.cn/api/thirdpart-service/oss/getImage?objectKey=" //企业认证图片路径域名
Vue.prototype.$companyApproveUrl = "https://service.jvtd.cn/api/thirdpart-service/oss/getImage?objectKey=" //企业认证图片路径域名
// 2.0---------------------------------------------------
// var getLastUrl=(str,yourStr)=>str.slice(str.lastIndexOf(yourStr))//取到浏览器出现网址的最后"/"出现的后边的字符
new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js